export default {
  zh: {},
  en: {},
  ar: {},
  tr: {},
  pt:{},
  id:{}
}


// WEBPACK FOOTER //
// src/pages/app/moment/lang.js